import { HashRouter as Router, Route, Switch, Redirect } from "react-router-dom";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { TeamsFxProvider } from "./contexts/TeamsFxContext";
import { AppProvider } from "./contexts/AppContext";

import Privacy from "./pages/Privacy";
import TermsOfUse from "./pages/TermsOfUse";
import MainPage from "./pages/MainPage";
import Config from "./pages/Config";
import { UtilitiesProvider } from "./contexts/UtilitiesContext";

const queryClient = new QueryClient();

export default function App() {
    return (
        <Router>
            <Switch>
                <Route path="/privacy" component={Privacy} />
                <Route path="/termsofuse" component={TermsOfUse} />

                <TeamsFxProvider>
                    <UtilitiesProvider>
                        <AppProvider>
                            <QueryClientProvider client={queryClient}>
                                <Route path="/" component={MainPage} />
                                <Route path="/config" component={Config} />
                            </QueryClientProvider>
                        </AppProvider>
                    </UtilitiesProvider>
                </TeamsFxProvider>

                <Route path="*">
                    <Redirect to={"/"} />
                </Route>
            </Switch>
        </Router>
    );
}
